
window.ClientSideEnv = {
  STRIPE_API_KEY: "pk_live_51Jp3zqKaGM6lHlRAaobWFqZC8KwpW9rRxoCchjvtda9wHUx28Dzf0NtfBscvM2f4tWAH1EDTZN3cm4tf0dnumYSb003qTZ14EQ",
  HOST: "community-capital.crfactory.com",
  MAIL_ADDRESS: "no-reply@crfactory.com",
  SUPPORT_MAIL_ADDRESS: "cclabo@crfactory.com",
  IS_TEST_MODE: "false",
}
